import { render, staticRenderFns } from "./ChoiceQuestionAIEdit.vue?vue&type=template&id=0985fe38&scoped=true"
import script from "./ChoiceQuestionAIEdit.vue?vue&type=script&lang=js"
export * from "./ChoiceQuestionAIEdit.vue?vue&type=script&lang=js"
import style0 from "./ChoiceQuestionAIEdit.vue?vue&type=style&index=0&id=0985fe38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0985fe38",
  null
  
)

export default component.exports